import React from "react";



const Booklist = () => {
    const pdfFiles = [
        { name: 'Booklist, HGS school Bhopal', url: '../newdocuments/Booklist Bhopal.xlsx'},
        { name: 'Booklist, HGS school Bhimtal', url: '../newdocuments/Booklist Bhimtal.xlsx'},
        { name: 'Booklist, HGS school Anangpur', url: '../newdocuments/Booklist anagpur.pdf'},
        { name: 'Booklist, HGS school Palla Nuh', url: '../newdocuments/boolist palla.pdf'},
        { name: 'Booklist, HGS school Varanasi', url: '../newdocuments/BOOK LIST 2025-26 varanasi.pdf'},
        { name: 'Booklist, HGS school Jammu', url: '../newdocuments/Book List of HGS school 2025-26 Jammu.xlsx'},
        { name: 'Booklist, HGS school Faridabad', url: '../newdocuments/Faridabad- Final Book List of HGS school 2025-2026.pdf'}
      
      ];
  
 
  return (
    <div className="home_main">
      {/* <Navbar isScrolled={true} handleClick={handleClick} /> */}
      <div className="pdf-container">
      <table className="pdf-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Filename</th>
            <th>Link To Documents</th>
          </tr>
        </thead>
        <tbody>
          {pdfFiles.map((file, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{file.name}</td>
              <td>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  View
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
      
    </div>
  );
};

export default Booklist;
